import React, { Fragment } from 'react'
import Img1 from "../images/page.png"
import usePageMeta from '../../hooks/usePageMeta'

const PageNotFound = () => {
    usePageMeta("notFound");

    return (
        <Fragment>
            <section className="pageNotFound flex">
                <div>
                    <img src={Img1} alt="" />
                </div>
            </section>
        </Fragment>
    )
}

export default PageNotFound